import { useSyncExternalStore } from 'react';
import {
  getResolvedTheme,
  getThemeMode,
  subscribeToTheme,
  type ResolvedTheme,
  type ThemeMode,
} from '../lib/theme';

/** The chosen mode, including `system`. Use for the theme picker's own state. */
export function useThemeMode(): ThemeMode {
  return useSyncExternalStore(subscribeToTheme, getThemeMode);
}

/** The theme actually on screen, with `system` already resolved against the OS. */
export function useResolvedTheme(): ResolvedTheme {
  return useSyncExternalStore(subscribeToTheme, getResolvedTheme);
}
